module.exports = __webpack_public_path__ + "static/media/66-iveco-mercedes.ed55c335.jpg";